import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { AdminNav } from "@/components/admin/AdminNav";
import { AdminAccessDenied } from "@/components/admin/AdminAccessDenied";
import { AdminLoading, useAdminAuth } from "@/components/admin/useAdminAuth";

const NAV = [
    ["Overview", "/admin/agent-os"],
    ["Agents", "/admin/agent-os/agents"],
    ["Tasks", "/admin/agent-os/tasks"],
    ["Missions", "/admin/agent-os/missions"],
    ["Models", "/admin/agent-os/models"],
    ["Model Review", "/admin/agent-os/model-review"],
    ["Canaries", "/admin/agent-os/canaries"],
    ["Pilot", "/admin/agent-os/pilot"],
    ["Vector Store", "/admin/agent-os/vector-store"],
    ["Routing", "/admin/agent-os/routing"],
    ["Prompts", "/admin/agent-os/prompts"],
    ["Scorecards", "/admin/agent-os/scorecards"],
    ["Evaluations", "/admin/agent-os/evaluations"],
    ["Knowledge", "/admin/agent-os/knowledge"],
    ["Provider", "/admin/agent-os/provider"],
    ["Tools", "/admin/agent-os/tools"],
    ["Approvals", "/admin/agent-os/approvals"],
    ["Memory", "/admin/agent-os/memory"],
    ["Usage", "/admin/agent-os/usage"],
    ["Audit", "/admin/agent-os/audit"],
];

export const AgentOSLayout = ({ title, subtitle, children, actions }) => {
    const { user, logout, hasPermission } = useAdminAuth();
    const { pathname } = useLocation();
    if (!user) return <AdminLoading />;
    if (!hasPermission("agent_os")) {
        return (
            <div className="min-h-screen bg-[#F8FAFC] text-ink">
                <AdminNav active="agent-os" email={user.email} user={user} onLogout={logout} />
                <AdminAccessDenied section="Agent OS" />
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-ivory text-ink">
            <AdminNav active="agent-os" email={user.email} user={user} onLogout={logout} />
            <div className="border-b border-ink/10 bg-night text-ivory">
                <div className="mx-auto max-w-[1500px] px-6 py-8 lg:px-10">
                    <p className="text-[10px] font-semibold uppercase tracking-[0.3em] text-champagne">Afrinexa Agent OS</p>
                    <div className="mt-3 flex flex-wrap items-end justify-between gap-5">
                        <div>
                            <h1 className="font-serif text-3xl font-medium tracking-tight sm:text-4xl">{title}</h1>
                            {subtitle && <p className="mt-2 max-w-3xl text-sm leading-relaxed text-ivory/55">{subtitle}</p>}
                        </div>
                        {actions}
                    </div>
                    <nav data-testid="agent-os-nav" className="mt-8 flex gap-1 overflow-x-auto">
                        {NAV.map(([label, href]) => {
                            const active = href === "/admin/agent-os" ? pathname === href : pathname.startsWith(href);
                            return (
                                <a key={href} href={href} data-testid={`agent-os-nav-${label.toLowerCase().replace(/\s+/g, "-")}`} className={`whitespace-nowrap border px-4 py-2.5 text-[10px] font-semibold uppercase tracking-[0.16em] transition-colors ${active ? "border-champagne bg-champagne text-ink" : "border-ivory/15 text-ivory/55 hover:border-ivory/40 hover:text-ivory"}`}>
                                    {label}
                                </a>
                            );
                        })}
                    </nav>
                </div>
            </div>
            <motion.main initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.45 }} className="mx-auto max-w-[1500px] px-6 py-8 lg:px-10">
                {children}
            </motion.main>
        </div>
    );
};
